module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_cycle-f981c8ee1d22092662c677fcf068a537.jpg";